import { render, staticRenderFns } from "./PermissionUpdateForm.vue?vue&type=template&id=3544f9f1&scoped=true&"
import script from "./PermissionUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PermissionUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544f9f1",
  null
  
)

export default component.exports